// extracted by mini-css-extract-plugin
module.exports = {"select":"ContentSwitcher_select__gtOrh","buttonGroup":"ContentSwitcher_buttonGroup__MmXKr"};